
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    label: { type: String, required: true },
    defaultOpen: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpen: this.defaultOpen,
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
});
